export const FETCH_CATEGORIES = 'FETCH_CATEGORIES'
export const FETCH_CATEGORIES_ERROR = 'FETCH_CATEGORIES_ERROR'
export const FETCH_CATEGORIES_PENDING = 'FETCH_CATEGORIES_PENDING'
export const FETCH_CATEGORIES_FULFILLED = 'FETCH_CATEGORIES_FULFILLED'

export const FETCH_LANGUAGES = 'FETCH_LANGUAGES'
export const FETCH_LANGUAGES_ERROR = 'FETCH_LANGUAGES_ERROR'
export const FETCH_LANGUAGES_PENDING = 'FETCH_LANGUAGES_PENDING'
export const FETCH_LANGUAGES_FULFILLED = 'FETCH_LANGUAGES_FULFILLED'

export const FETCH_USER_TOPICS = 'FETCH_USER_TOPICS'
export const FETCH_USER_TOPICS_ERROR = 'FETCH_USER_TOPICS_ERROR'
export const FETCH_USER_TOPICS_PENDING = 'FETCH_USER_TOPICS_PENDING'
export const FETCH_USER_TOPICS_FULFILLED = 'FETCH_USER_TOPICS_FULFILLED'

export const FETCH_VERTICALS = 'FETCH_VERTICALS'
export const FETCH_VERTICALS_ERROR = 'FETCH_VERTICALS_ERROR'
export const FETCH_VERTICALS_PENDING = 'FETCH_VERTICALS_PENDING'
export const FETCH_VERTICALS_FULFILLED = 'FETCH_VERTICALS_FULFILLED'

export const EDIT_TOPIC = 'EDIT_TOPIC'
export const EDIT_TOPIC_FULFILLED = 'EDIT_TOPIC_FULFILLED'
export const EDIT_TOPIC_PENDING = 'EDIT_TOPIC_PENDING'

export const DELETE_TOPIC = 'DELETE_TOPIC'
export const DELETE_TOPIC_PENDING = 'DELETE_TOPIC_PENDING'
export const DELETE_TOPIC_FULFILLED = 'DELETE_TOPIC_FULFILLED'

export const ADD_TOPIC = 'ADD_TOPIC'
export const ADD_TOPIC_PENDING = 'ADD_TOPIC_PENDING'
export const ADD_TOPIC_FULFILLED = 'ADD_TOPIC_FULFILLED'

export const FETCH_ALL_TOPICS = 'FETCH_ALL_TOPICS'
export const FETCH_ALL_TOPICS_FULFILLED = 'FETCH_ALL_TOPICS_FULFILLED'
export const FETCH_ALL_TOPICS_PENDING = 'FETCH_ALL_TOPICS_PENDING'
export const FETCH_ALL_TOPICS_ERROR = 'FETCH_ALL_TOPICS_ERROR'

export const APPROVE_USER_TOPIC = 'APPROVE_USER_TOPIC'
export const APPROVE_USER_TOPIC_ERROR = 'APPROVE_USER_TOPIC_ERROR'
export const APPROVE_USER_TOPIC_PENDING = 'APPROVE_USER_TOPIC_PENDING'
export const APPROVE_USER_TOPIC_FULFILLED = 'APPROVE_USER_TOPIC_FULFILLED'

export const REJECT_USER_TOPIC = 'REJECT_USER_TOPIC'
export const REJECT_USER_TOPIC_ERROR = 'REJECT_USER_TOPIC_ERROR'
export const REJECT_USER_TOPIC_PENDING = 'REJECT_USER_TOPIC_PENDING'
export const REJECT_USER_TOPIC_FULFILLED = 'REJECT_USER_TOPIC_FULFILLED'

export const ADD_CATEGORY_FULFILLED = 'ADD_CATEGORY_FULFILLED'
export const DELETE_CATEGORY_FULFILLED = 'DELETE_CATEGORY_FULFILLED'
export const EXPORT_CATEGORY_FULFILLED = 'EXPORT_CATEGORY_FULFILLED'
export const EDIT_CATEGORY_FULFILLED = 'EDIT_CATEGORY_FULFILLED'

export const FETCH_TOPICS_ERROR = 'FETCH_TOPICS_ERROR'
export const FETCH_TOPICS_FULFILLED = 'FETCH_TOPICS_FULFILLED'
export const FETCH_TOPICS_PENDING = 'FETCH_TOPICS_PENDING'

export const TOGGLE_INCLUDE_USED_TOPICS = 'TOGGLE_INCLUDE_USED_TOPICS'
